module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_1-b38eba2f16f00cb35d88b32df8ae19f4.jpg";